import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, NgForm} from "@angular/forms";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {LicensedAgent} from "../../../../shared/interface/licensed-agent";
import {Employee} from "../../../../shared/interface/employee";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../../shared/services/auth.service";
import {FilterService} from "../../../../shared/services/filter.service";
import {ActivatedRoute, Router} from "@angular/router";
import {select, Store} from "@ngrx/store";
import {StoreRootState} from "../../../../shared/ngrx/reducers";
import {MatDialog} from "@angular/material/dialog";
import {DictService} from "../../../../shared/services/dict.service";
import {delay, distinctUntilChanged, first, takeUntil, tap} from "rxjs/operators";
import {CountedAndPaginated} from "../../../../shared/interface/response/counted-and-paginated";
import {EmployeeService} from "../../../../shared/services/employee.service";
import {getCurrentRouteState} from "../../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../../shared/ngrx/route-serializer";
import {Uuid} from "../../../../shared/interface/response/uuid";
import {JobResultDialogComponent} from "../../../../shared/components/job-result-dialog/job-result-dialog.component";
import {HttpErrorResponse} from "@angular/common/http";

@Component({
  selector: 'app-all-employee-list',
  templateUrl: './all-employee-list.component.html',
  styleUrls: ['./all-employee-list.component.scss']
})
export class AllEmployeeListComponent  implements AfterViewInit, OnInit, OnDestroy {
  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Input() embeddedView = false;

  items: Employee[] = [];
  initialFilters: any;
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;
  displayedColumns: string[] = ['name', 'phone', 'email', 'employmentAt', 'employmentTo'];


  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);


  constructor(
    private employeeService: EmployeeService,
    private fb: FormBuilder,
    private snack: MatSnackBar,
    private auth: AuthService,
    private filterService: FilterService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private store: Store<StoreRootState>,
    private dialog: MatDialog,
    private dictService: DictService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.employeeService.employeeListSubject
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<LicensedAgent>) => {
          this.items = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
    this.parseFilters();
  }

  ngOnInit(): void {
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      gte$employmentAt: 'date',
      lte$employmentAt: 'date',
      email: 'string',
      phoneNumber: 'string',
      employee: 'string'
    }, filters);
  }

  ngAfterViewInit(): void {
    this.activatedRoute.data
      .pipe(
        delay(0),
        first()
      )
      .subscribe((data: any) => {
        if (!this.embeddedView) {
          this.store
            .pipe(
              select(getCurrentRouteState),
              delay(0),
              distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
              takeUntil(this.destroyed$),
            )
            .subscribe((state: RouterStateUrl) => {
              this.parseFilters(state.params);
              this.paginator.pageIndex = state.params.page;
              this.paginator.pageSize = state.params.pageSize;
              this.loadListData();
            });
        } else {
          this.loadListData();
        }
      });
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      if (this.embeddedView) {
        this.loadListData();
      } else {
        this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
          page: event.pageIndex,
          pageSize: event.pageSize,
          ...this.filtersForm.value
        })]);
      }
    });
  }

  async loadListData(): Promise<void> {
    this.employeeService.loadList(
      this.paginator.pageIndex,
      this.paginator.pageSize,
      this.buildFilters()
    );
  }

  buildFilters(): any {
    const filters = {...this.initialFilters};

    return filters;
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    if (this.embeddedView) {
      this.loadListData();
    } else {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
        page: 0,
        pageSize: this.paginator.pageSize,
      }]);
    }

  }
  filter(): void {
    if (this.embeddedView) {
      if (this.paginator.pageIndex === 0) {
        this.loadListData();
      } else {
        this.paginator.firstPage();
      }
    } else {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: 0,
        pageSize: this.paginator.pageSize,
        ...this.filtersForm.value,
      })]);
    }
  }
  downloadReport(): void {
    this.employeeService.downloadReport(this.buildFilters())
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }
}
